import { getOptionValue } from "./options";

export const defaultGrid = {
  grid: { headerDef: [], rowDef: [], data: [], span: [] },
};

/**
 * Update the value of an option in a DataGrid
 *
 * @param {GridData} grid
 * @param {Option} option
 * @returns
 */
export const handleOptionChange = (grid, option) => {
  let { data } = grid;

  data.forEach((row, rowIndex) => {
    row.cellData.forEach((cell, cellIndex) => {
      if (cell.data.code === option.code) {
        data[rowIndex].cellData[cellIndex].data = option;
      }
    });
  });

  return { ...grid, data };
};

/**
 * Iterates through a DataGrid and generates an object of all inputs and their values.
 * Typically used by summaries.
 *
 * @param {GridData} data
 * @returns
 */
export const processDetails = (data) => {
  const details = {};

  data.forEach((row, rowIndex) => {
    row.cellData.forEach((cell, cellIndex) => {
      if (cell.type === "control") {
        details[cell.data.code] = getOptionValue(cell.data);
      }
    });
  });

  return details;
};

export const wait = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time));
};
